const patientTableColumns = {
  name_id: {
    key: "name_id",
    title: "Name / ID",
    display: true,
    mandatory: true,
    id: "name"
  },
  dob: {
    key: "dob",
    title: "DOB",
    display: true,
    mandatory: false,
    id: "dob"
  },
  isActive: {
    key: "isActive",
    title: "Active/Inactive",
    display: false,
    mandatory: false,
    id: "isActive"
  },
  assigneeNames: {
    key: "assigneeNames",
    title: "Assignee",
    display: true,
    mandatory: false,
    id: "assignee"
  },
  tmDisplayName: {
    key: "tmDisplayName",
    title: "Medication Name",
    display: true,
    mandatory: false,
    id: "tm-display-name"
  },
  doseFormCategory: {
    key: "doseFormCategory",
    title: "Dose Form Category",
    display: true,
    mandatory: false,
    id: "dose-form-category"
  },
  dosageDisplay: {
    key: "dosageDisplay",
    title: "Dosage",
    display: true,
    mandatory: false,
    id: "dosageDisplay"
  },
  unitCost: {
    key: "unitCost",
    title: "Unit Price",
    display: false,
    mandatory: false,
    id: "unit-cost"
  },
  totalAmount: {
    key: "totalAmount",
    title: "Total Order Price",
    display: false,
    mandatory: false,
    id: "total-amount"
  },
  assistance_program_name: {
    key: "assistance_program_name",
    title: "Program Name",
    display: true,
    mandatory: false,
    id: "assistance-program-name"
  },
  drug_manufacturer: {
    key: "drug_manufacturer",
    title: "Program Sponsor",
    display: false,
    mandatory: false,
    id: "drug-manufacturer"
  },
  facility: {
    key: "facility",
    title: "Facility",
    display: false,
    mandatory: false,
    id: "facility"
  },
  physician: {
    key: "physician",
    title: "Physician",
    display: false,
    mandatory: false,
    id: "physician"
  },
  order_date: {
    key: "order_date",
    title: "Order Date",
    display: true,
    mandatory: false,
    id: "order-date"
  },
  admin_date: {
    key: "admin_date",
    title: "Admin Date",
    display: true,
    mandatory: false,
    id: "admin-date"
  },
  last_admin: {
    key: "last_admin",
    title: "Last Admin",
    display: true,
    mandatory: false,
    id: "last-admin"
  },
  estimated_delivery: {
    key: "estimated_delivery",
    title: "Estimated Delivery",
    display: false,
    mandatory: false,
    id: "estimated-delivery"
  },
  arrive_date: {
    key: "arrive_date",
    title: "Received Date",
    display: true,
    mandatory: false,
    id: "received-date"
  },
  order_type: {
    key: "order_type",
    title: "Order Type",
    display: true,
    mandatory: false,
    id: "order-type"
  },
  cycle_number: {
    key: "cycle_number",
    title: "Order #",
    display: true,
    mandatory: false,
    id: "cycle-number"
  },
  status: {
    key: "status",
    title: "Order Status",
    display: true,
    mandatory: false,
    id: "cycle-status"
  },
  action: {
    key: "action",
    title: "Order Action",
    display: true,
    mandatory: true,
    id: "cycle-action"
  },
  notes: {
    key: "notes",
    title: "Notes",
    display: true,
    mandatory: false,
    id: "notes"
  },
  attachments: {
    key: "attachments",
    title: "Attach",
    display: true,
    mandatory: false,
    id: "attachments"
  },
  viewedAt: {
    key: "viewedAt",
    title: "Last Viewed",
    display: true,
    mandatory: false,
    hidden: true,
    id: "viewedAt"
  }
};

export { patientTableColumns };
